import collaboratorClient from '.'
import { getAuthHeaders } from 'utils/requests'

const me = async () => {
    const headers = { headers: getAuthHeaders() }
  return await collaboratorClient.get('/me', headers)
}

export default me
